import React from 'react';

const MapTypeSwitchButton = ({currentType, onTypeChange, hasCompareData}) => {
    const modes = hasCompareData ? ['base', 'compare', 'sidebyside'] : ['base'];
    const colors = {
        base: '#1890ff',
        compare: '#52c41a',
        sidebyside: '#035781'
    };
    const labels = {
        base: 'B',
        compare: 'C',
        sidebyside: 'S'
    };
    const titles = {
        base: 'Base model',
        compare: 'Compare model',
        sidebyside: 'Side-by-side'
    };

    const handleClick = () => {
        if (!hasCompareData) return;
        const currentIndex = modes.indexOf(currentType);
        const nextIndex = (currentIndex + 1) % modes.length;
        onTypeChange(modes[nextIndex]);
    };

    const buttonStyle = {
        width: '35px',
        height: '35px',
        backgroundColor: colors[currentType] || colors.base,
        border: 'none',
        borderRadius: '2px',
        cursor: hasCompareData ? 'pointer' : 'not-allowed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'white',
        opacity: hasCompareData ? 1 : 0.5,
        transition: 'all 0.2s'
    };

    return (
        <button 
            style={buttonStyle} 
            onClick={handleClick}
            title={hasCompareData ? `${titles[currentType]} (Click to switch)` : 'No compare data'}
        >
            {labels[currentType] || 'B'}
        </button>
    );
};

export default MapTypeSwitchButton;
